import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import * as fromAuthStore from 'src/app/auth/store';
import { AuthActionTypes } from 'src/app/auth/store';
import { EMAIL_VALIDATION } from 'src/utils/constants';
import { IPhoneInfo } from 'src/utils/declarations';
import { cleanTelNumber } from 'src/utils/helpers';

@Component({
  selector: 'app-login-component',
  templateUrl: './login-component.component.html',
  styleUrls: ['./login-component.component.scss'],
})
export class AuthLoginComponent implements OnInit, OnDestroy {
  activeField: string = 'email';
  showPassword: boolean = false;
  userEmail: string = '';
  userPassword: string = '';
  phoneInfo: IPhoneInfo = {
    code: 0,
    isInvalid: false,
    isDirty: false,
    value: '',
  };
  loginError: boolean = false;

  destroyed$ = new Subject<boolean>();

  constructor(
    private authStore: Store<fromAuthStore.State>,
    private router: Router,
    private actionsSubject: ActionsSubject
  ) {
    this.actionsSubject
      .pipe(ofType(AuthActionTypes.LOGIN_ERROR))
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data: any) => {
        this.loginError = true;
      });
  }

  ngOnInit(): void {}

  login() {
    const phone = cleanTelNumber(this.phoneInfo.value);

    this.authStore.dispatch(
      new fromAuthStore.Login({
        email: this.activeField === 'email' ? this.userEmail : '',
        phone: this.activeField === 'email' ? '' : phone,
        password: this.userPassword,
      })
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleEnter(field: string) {
    if (
      this.userPassword === '' ||
      (this.activeField === 'email' && this.userEmail === '') ||
      (this.activeField === 'phone' && this.phoneInfo.value === '')
    ) {
      if (field === 'login') {
        const input = document.querySelector(
          '#password-item'
        ) as HTMLElement | null;
        if (input !== null) {
          input.focus();
        }
      }
      if (field === 'password') {
        const input = document.querySelector(
          '#login-item'
        ) as HTMLElement | null;
        if (input !== null) {
          input.focus();
        }
      }
    } else {
      this.login();
    }
  }

  changePhoneInfo(eventData: IPhoneInfo) {
    this.phoneInfo = eventData;
  }

  checkValid() {
    const passwordIsValid = this.userPassword !== '';

    const emailOrPhoneValidBySelectedField =
      (this.activeField === 'email' && EMAIL_VALIDATION) ||
      (this.activeField !== 'email' &&
        !this.phoneInfo.isInvalid &&
        this.phoneInfo.value &&
        this.phoneInfo.code);
    return passwordIsValid && emailOrPhoneValidBySelectedField;
  }
}
